module.exports = __webpack_public_path__ + "img/link.93c8c3d0.svg";